<template>
<div class="content-bar">
        <router-link to="/">首页</router-link>
        <router-link  v-scroll-to="'#business'" to="/">主营业务</router-link >
        <router-link  v-scroll-to="'#product'" to="/">产品优势</router-link >
        <router-link to="/contact-us">联系我们</router-link>
      </div>
</template>

<script>
export default {

}
</script>

<style lang="stylus" scoped>

</style>
